import api from '@/services/api'
import jsonp from 'jsonp'

export default {
  state: {},

  mutations: {},

  actions: {
    validateCNPJ({ commit }, cnpj) {
      try {
        return new Promise((resolve, reject) => {
          jsonp(
            `https://receitaws.com.br/v1/cnpj/${cnpj}`,
            null,
            (err, res) => {
              if (!err) {
                resolve(res)
              } else {
                reject(err)
              }
            },
          )
        })
      } catch (error) {
        throw error
      }
    },

    async createRegister({ commit }, data) {
      try {
        return await api.post('register', data)
      } catch (error) {
        throw error
      }
    },
  },

  getters: {},
}
